// components/PopupVendor/VendorLanguagesSection.js
import React from 'react';

const VendorLanguagesSection = ({
                                    isCurrentUserVendorOwner,
                                    languages = [],
                                    handlerShowEditLanguagesPopup
                                }) => {
    if (!isCurrentUserVendorOwner && languages.length === 0) {
        return null;
    }

    return (
        <div className="profile__block">
            <div className="container">
                <div className="profile__header"><h2>Languages</h2>
                    {isCurrentUserVendorOwner && (
                        <button className="button no-style" onClick={handlerShowEditLanguagesPopup}>
                            <img src="/assets/icon--edit-Z9QfuMgm.svg" alt="Edit Languages"/>
                            {(languages.length === 0) ? 'Add Languages' : 'Edit Languages'}
                        </button>
                    )}
                </div>
                <div className="profile__content">
                    <ul className="params__list">
                        {languages.map((lang, index) => (
                            <li key={index}>{lang.name} ({lang.proficiency_level})</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default VendorLanguagesSection;